import { handleResponseError } from 'helpers/utils'
import { API } from './endpoint'
import httpClient from '../axios/interceptors'
import { AxiosResponse } from 'axios'
import {
  FilterParcelCustomerListInput,
  ParcelCustomerByAgentInput,
  ParcelCustomerIdentityInput,
  UpdateParcelAddressInput,
  ParcelCustomerListResponse,
  ParcelCustomerAddressesResponse,
  ParcelCustomerParcelsResponse,
  UpdateParcelAddressResponse,
  DeleteParcelAddressResponse,
} from './interface/parcelCustomers.interface'

export const getParcelCustomerList = async (
  input: FilterParcelCustomerListInput
): Promise<ParcelCustomerListResponse> => {
  const data: AxiosResponse<ParcelCustomerListResponse> = await httpClient
    .post(API.factoryParcelCustomers, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const getParcelCustomerAddresses = async (
  input: ParcelCustomerIdentityInput
): Promise<ParcelCustomerAddressesResponse> => {
  const data: AxiosResponse<ParcelCustomerAddressesResponse> = await httpClient
    .post(API.factoryParcelCustomerAddresses, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const getParcelCustomerParcels = async (
  input: ParcelCustomerByAgentInput
): Promise<ParcelCustomerParcelsResponse> => {
  const data: AxiosResponse<ParcelCustomerParcelsResponse> = await httpClient
    .post(API.factoryParcelCustomerParcels, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const updateParcelAddress = async (
  id: string,
  input: UpdateParcelAddressInput
): Promise<UpdateParcelAddressResponse> => {
  const data: AxiosResponse<UpdateParcelAddressResponse> = await httpClient
    .patch(API.factoryParcelAddressUpdate(id), input)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const deleteParcelAddress = async (
  id: string
): Promise<DeleteParcelAddressResponse> => {
  const data: AxiosResponse<DeleteParcelAddressResponse> = await httpClient
    .delete(API.factoryParcelAddressDelete(id))
    .catch((error) => handleResponseError(error))
  return data.data
}
